// Asset management utilities
export const AssetConfig = {
  images: {
    logo: {
      default: "/assets/images/logo.png",
      color: "/assets/images/logo-color.png",
      white: "/assets/images/logo-white.png",
      color1: "/assets/images/logo-color1.png",
    },
    hero: "/assets/images/home-banner.png",
    process: {
      step1: "/assets/images/how1.png",
      step2: "/assets/images/how2.png",
      step3: "/assets/images/how3.png",
    },
    features: {
      business: "/assets/images/business.png",
      committed: "/assets/images/commited.png",
      getRewards: "/assets/images/get-rewards.png",
      marketResearch: "/assets/images/market-research.png",
      onlineArticle: "/assets/images/whyjoin.png",
      onlineCommunity: "/assets/images/online-community.png",
      reward: "/assets/images/reward.png",
      standout: "/assets/images/standout.png",
      sync: "/assets/images/sync.png",
    },
    contact: "/assets/images/contact.png",
    mail: "/assets/images/mail.png",
    padlock: "/assets/images/padlock.png",
    onlineArticle: "/assets/images/online-article.png",
    dashboard: {
      step1: "/assets/images/dashboard/step1.png",
      step2: "/assets/images/dashboard/step2.png",
      step3: "/assets/images/dashboard/step3.png",
      step4: "/assets/images/dashboard/step4.png",
      step5: "/assets/images/dashboard/step5.png",
      step6: "/assets/images/dashboard/step6.png",
    },
    bot: "/assets/images/bot.png",
    mobileWire: "/assets/images/mobile-wire.png",
    appDownload: "/assets/images/app-download.png",
    playStore: "/assets/images/play-store.png",
    whyJoin: "/assets/images/whyjoin.svg",
    dataProtection: "/assets/images/data-protection.svg",
    notFound: "/assets/images/not-found.png",
    joinUs: {
      image2: "/assets/images/join_us_image2.png",
      image3: "/assets/images/join_us_image3.png",
    },
    group46: "/assets/images/Group_46.png",
  },
  icons: {
    menu: "/assets/images/menu-icon.svg",
    favicon: "/assets/icons/favicon.ico",
    arrowLeft: "/assets/images/arrowleft.png",
    arrowRight: "/assets/images/arrowright.png",
  },
  patterns: {
    header: "/assets/images/header-pattern.7c3dc1c4768ede5149c3.png",
    contact: "/assets/images/pattern/contact.png",
  },
};

// Utility function to get asset path
export const getAssetPath = (path) => {
  return process.env.PUBLIC_URL + path;
};

// Utility function to get image with fallback
export const getImageWithFallback = (
  imagePath,
  fallback = "/assets/images/not-found.png"
) => {
  return imagePath || fallback;
};

// Theme configuration
export const ThemeConfig = {
  colors: {
    primary: "#007bff",
    secondary: "#6c757d",
    orange: "#5d2d91",
    success: "#28a745",
    danger: "#dc3545",
    warning: "#ffc107",
    info: "#17a2b8",
    light: "#f8f9fa",
    dark: "#343a40",
    white: "#fff",
  },
  fonts: {
    primary: "Poppins, sans-serif",
    weights: {
      light: 200,
      normal: 300,
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
      extrabold: 800,
      black: 900,
    },
  },
  breakpoints: {
    xs: "0px",
    sm: "576px",
    md: "768px",
    lg: "992px",
    xl: "1200px",
  },
  spacing: {
    xs: "0.25rem",
    sm: "0.5rem",
    md: "1rem",
    lg: "1.5rem",
    xl: "3rem",
  },
};

export default AssetConfig;
